import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import { Spinner } from '../components/ui/Spinner';
import { StatCard } from '../components/ui/StatCard';
import { useAuth } from '../context/AuthContext';

export function Overview() {
  const { currentSiteId } = useAuth();

  const { data, isLoading, isError } = useQuery({
    queryKey: ['overview', currentSiteId],
    queryFn: () => api.overview(currentSiteId!),
    enabled: !!currentSiteId,
  });

  if (!currentSiteId) {
    return <p className="text-sm text-slate-500">Keine Seite ausgewählt.</p>;
  }

  if (isLoading) {
    return (
      <div className="flex justify-center py-16">
        <Spinner />
      </div>
    );
  }

  if (isError || !data) {
    return <p className="text-sm text-rose-500">Daten konnten nicht geladen werden.</p>;
  }

  const { today, yesterday } = data;

  return (
    <div className="space-y-6">
      <h1 className="text-xl font-semibold text-slate-900 dark:text-white">Übersicht</h1>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
        <StatCard label="Besucher heute" value={today.visitors} previousValue={yesterday.visitors} />
        <StatCard label="Sessions" value={today.sessions} previousValue={yesterday.sessions} />
        <StatCard
          label="Conversion Rate"
          value={(today.conversionRate * 100).toFixed(1)}
          previousValue={(yesterday.conversionRate * 100).toFixed(1)}
          suffix="%"
        />
        <StatCard label="Telefon-Klicks" value={today.phoneClicks} previousValue={yesterday.phoneClicks} />
        <StatCard label="WhatsApp-Klicks" value={today.whatsappClicks} previousValue={yesterday.whatsappClicks} />
      </div>
    </div>
  );
}
